import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Wrapper, Button, Menu, MenuItem } from 'react-aria-menubutton';

const Strings = require('../../../../../app/shared/Strings');
const SignInActions = require('../../../actions/sign_in_actions');
const SignInStore = require('../../../stores/SignInStore');
const Globals = require('../../../../../app/globals');
import Navigator from '../../../Navigator';
import AvatarButton from './AvatarButton';

const propTypes = {
    history: PropTypes.object.isRequired,
    role: PropTypes.string, // Globals.users.local_role_type ( STUDENT or AUTHOR )
    minimizeBreakpoint: PropTypes.oneOf(['sm', 'md']),
};

const defaultProps = {
    minimizeBreakpoint: 'sm',
};

class AccountDropdown extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            signInStoreState: SignInStore.getState()
        };

        this.unsubscribes = [
            SignInStore.listen(this.onSignInStoreChange.bind(this))
        ];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onSignInStoreChange(state) {
        this.setState({ signInStoreState: state });
    }

    signOutHandler=()=>{
        SignInActions.signOut();
    }

    adminHandler=()=>{
        this.props.history.push('/admin/settings');
    }

    settingsHandler=()=>{
        this.props.history.push('/settings');
    }

    selectHandler=(value)=>{
        switch(value){
            case 'student_role':
                Navigator.goToDashboardStudent(this.props.history);
                break;
                
            case 'instructor_role':
                Navigator.goToDashboardAuthor(this.props.history);
                break;
            
            case 'signOut':
            this.signOutHandler();
            break;
            case 'admin':
            this.adminHandler();
            break;
            case 'settings':
            this.settingsHandler();
            break;
        }
    }

	render() {
        let menuItems = [
            (this.props.role == Globals.users.local_role_type.AUTHOR) ?
                { content: Strings['en'].dashboard.account.STUDENT_ROLE, value: 'student_role' }
                : 
                { content: Strings['en'].dashboard.account.INSTRUCTOR_ROLE, value: 'instructor_role' },
                { divider: true, value: 'div1' },
        ]

        if (this.state.signInStoreState.userInfo.admin) {
            menuItems.push({ content: Strings['en'].dashboard.account.ADMIN, value: 'admin' });
        }
        
        menuItems = menuItems.concat([
            { content: Strings['en'].dashboard.account.SETTINGS, value: 'settings' },
            { content: Strings['en'].dashboard.account.SIGN_OUT, value: 'signOut' }
        ]);

        let textButtonDispClass;
        let iconButtonDispClass;
        if (this.props.minimizeBreakpoint === 'sm' || !this.props.minimizeBreakpoint) {
            textButtonDispClass = 'd-none d-sm-inline';
            iconButtonDispClass = 'd-inline d-sm-none';
        }
        else if (this.props.minimizeBreakpoint === 'md') {
            textButtonDispClass = 'd-none d-lg-inline';
            iconButtonDispClass = 'd-inline d-lg-none';
        }
        else {
            textButtonDispClass = 'd-none d-sm-inline';
            iconButtonDispClass = 'd-inline d-sm-none';
        }

		return (
            <span className="account-dropdown">
                <Wrapper
                    className='AriaMenuButton'
                    onSelection={this.selectHandler}
                >
                    <Button className='AriaMenuButton-trigger AriaMenuButton-trigger--bare-text'>
                        <span className={textButtonDispClass}>
                            <AvatarButton userInfo={this.state.signInStoreState.userInfo} />
                        </span>
                        <span className={iconButtonDispClass}>
                            <span className="fa fa-user-circle-o" aria-hidden="true" />
                            <span className="sr-only">{Strings['en'].dashboard.account.MENU_TITLE}</span>
                        </span>
                    </Button>
                    <Menu>
                        <ul className='AriaMenuButton-menu AriaMenuButton-menu--flushRight'>
                            {menuItems.map((item) => {
                                if (item.divider) {
                                    return (
                                        <li className='AriaMenuButton-menuItemWrapper' key={item.value}>
                                            <hr role="divider" className="AriaMenuButton-menuItemDivider"/>
                                        </li>
                                    );
                                }

                                return (
                                    <li className='AriaMenuButton-menuItemWrapper' key={item.value}>
                                        <MenuItem
                                            className="AriaMenuButton-menuItem no-bottom-line"
                                            value={item.value}
                                            text={item.content}
                                        >
                                                {item.content}
                                        </MenuItem>
                                    </li>
                                );
                            })}
                        </ul>
                    </Menu>
                </Wrapper>
            </span>
		);
	}
}

AccountDropdown.propTypes = propTypes;
AccountDropdown.defaultProps = defaultProps;

export default withRouter(AccountDropdown);
